import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import { initializeGoogleAnalytics } from '../lib/analytics';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const hasConsent = localStorage.getItem('cookieConsent');
    if (!hasConsent) {
      setIsVisible(true);
    } else if (hasConsent === 'accepted') {
      // Initialize Google Analytics if consent was previously given
      initializeGoogleAnalytics();
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    initializeGoogleAnalytics();
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  return isVisible ? (
    <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 shadow-lg z-50 p-4 md:p-6 border-t dark:border-gray-700">
      <div className="container mx-auto max-w-6xl flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex-1">
          <p className="text-gray-700 dark:text-gray-200 text-sm md:text-base">
            Wir verwenden Cookies und ähnliche Technologien, um Ihnen ein besseres Nutzungserlebnis bieten zu können. 
            Mit Ihrer Zustimmung verwenden wir Cookies für Analysezwecke (Google Analytics). 
            Weitere Informationen finden Sie in unserer{' '}
            <a href="/datenschutz" className="text-[var(--primary-color)] hover:underline">
              Datenschutzerklärung
            </a>.
          </p>
        </div>
        <div className="flex items-center gap-4">
          <button
            onClick={declineCookies}
            className="px-4 py-2 text-gray-600 dark:text-gray-300 hover:text-gray-800 dark:hover:text-gray-100 transition-colors"
          >
            Ablehnen
          </button>
          <button
            onClick={acceptCookies}
            className="px-6 py-2 bg-[var(--primary-color)] text-white rounded-md hover:opacity-90 transition-opacity"
          >
            Akzeptieren
          </button>
        </div>
        <button
          onClick={declineCookies}
          className="absolute top-2 right-2 text-gray-400 dark:text-gray-400 hover:text-gray-600 dark:hover:text-gray-200 md:hidden"
          aria-label="Schließen"
        >
          <X size={20} />
        </button>
      </div>
    </div>
  ) : null;
};

export default CookieConsent;